import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';
import { BuildingsPerMunicipalityModel } from './../../models/buildings-per-municipality.model';
import {
  GetBuildingsPerPeriod,
  GetBuildingsPerMunicipality,
} from './../../ngxs/action/dashboard.action';
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { DashboardState } from '../../ngxs/state/dashboard.state';
import { Observable, Subscription } from 'rxjs';
import * as Highcharts from 'highcharts';

window.Highcharts = Highcharts;

// import 'highcharts-ng';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
})
export class LineChartComponent implements OnInit, OnDestroy {
  subscription = new Subscription();

  @Select(DashboardState.buildingsPerMunicipality)
  buildingsPerMunicipality$: Observable<BuildingsPerMunicipalityModel[]>;

  Highcharts: typeof Highcharts = Highcharts;

  chartOptions: Highcharts.Options = {
    series: [],
  };

  buildingsByMunicipalityLabel = '';

  constructor(
    private store: Store,
    private translateService: TranslateService,
    private localizationService: LocalizationService
  ) {
    this.translateLabels();
  }

  translateLabels() {
    this.buildingsByMunicipalityLabel = this.localizationService.translate(
      'buildings-by-municipality'
    );
  }

  drawPie(model: BuildingsPerMunicipalityModel[]) {
    this.chartOptions = {
      chart: {
        styledMode: true,
        plotBorderWidth: null,
        plotShadow: false,
      },
      title: {
        text: this.buildingsByMunicipalityLabel,
      },
      tooltip: {
        pointFormat:
          '{series.name}: {point.y} (<b>{point.percentage:.1f}%</b>)',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',

          dataLabels: {
            enabled: false,
          },

          showInLegend: true,
        },
      },
    };

    const sumPerPeriod = [];
    model.forEach((x) => {
      sumPerPeriod.push({
        name: x.municipality.name,
        sum: x.buildings,
      });
    });

    const data = [];

    sumPerPeriod.forEach((x) => {
      const item: (string | number)[] = [x.name, x.sum];
      data.push(item);
    });

    this.chartOptions.series = [
      {
        type: 'pie',
        name: `Згради`,
        data: data,
      },
    ];
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.store.dispatch(new GetBuildingsPerMunicipality());

    this.subscription.add(
      this.translateService.onLangChange.subscribe((x) => {
        if (x) {
          this.store.dispatch(new GetBuildingsPerMunicipality());
        }
      })
    );

    this.subscription.add(
      this.buildingsPerMunicipality$.subscribe((x) => {
        if (x) {
          this.drawPie(x);
        }
      })
    );

    this.subscription.add(
      this.translateService.onLangChange.subscribe((x) => {
        if (x) {
          this.translateLabels();
        }
      })
    );
  }
}
